export default [
    {
        path: "/article/index/:id",
        name: "/article/index",
        component: resolve => require(["./Index.vue"], resolve)
    }
];



// WEBPACK FOOTER //
// ./src/views/article/router.js